import { defaultQueryClientConfig } from '@iheartjane/react-query-utils';
import type { CustomThemeConfig } from '@iheartjane/reefer';
import { QueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { createBrowserRouter } from 'react-router';

import { JaneApplicationWrapper } from '@jane/shared/components';

import { createRoutes } from './routes';

const BUSINESS_THEME: CustomThemeConfig = {
  borderRadius: {
    xs: '8px',
    sm: '12px',
  },
  components: {
    Button: {
      shared: {
        borderRadius: 'sm',
      },
      variants: {
        tertiary: {
          backgroundColor: 'grays-ultralight',
          borderColor: 'grays-ultralight',
          typographyColor: 'grays-black',
          typographyVariant: 'body-bold',
        },
      },
    },
    Card: {
      styles: {
        borderRadius: 'lg',
      },
    },
  },
};

const App = () => {
  const queryClient = useMemo(
    () => new QueryClient(defaultQueryClientConfig),
    []
  );

  const router = useMemo(() => {
    const routesObject = createRoutes();
    return createBrowserRouter(routesObject);
  }, []);

  return (
    <JaneApplicationWrapper
      theme={BUSINESS_THEME}
      router={router}
      queryClient={queryClient}
    />
  );
};

export default App;
